import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { PUT_TAKING_SURVEY } from './constants';
import {
  PutTakingSurveyActionTypes,
  IPutTakingSurveySuccess,
  IPutTakingSurveyError,
  IPutTakingSurveyState,
} from './types';

const initialState: IPutTakingSurveyState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: PutTakingSurveyActionTypes,
  ): IPutTakingSurveyState => {
    switch (action.type) {
      case PUT_TAKING_SURVEY + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case PUT_TAKING_SURVEY + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as IPutTakingSurveySuccess).payload;
        break;
      }
      case PUT_TAKING_SURVEY + FAILURE: {
        draft.status = rejected;
        draft.error = (action as IPutTakingSurveyError).error;
        break;
      }
      default:
        return draft;
    }
  },
);
